module.exports = __webpack_public_path__ + "static/wheel-bg.82c0c995.png";